import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { SimpleCard1ComponentModule } from '../simple-card1/simple-card1.component';


@Component({
  selector: 'lcms-viewsimple1',
  templateUrl: './viewsimple1.component.html',
  styleUrls: ['./viewsimple1.component.scss'],
})
export class Viewsimple1Component {
  chartOptions: any = {};
  @Input() data: any;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {

  }

}



@NgModule({
  imports: [CommonModule,SimpleCard1ComponentModule],
  declarations: [Viewsimple1Component],
  exports: [Viewsimple1Component],
})
export class Viewsimple1ComponentModule {}
